import { render, staticRenderFns } from "./ModelCrudButtons.vue?vue&type=template&id=6edbc19d"
import script from "./ModelCrudButtons.vue?vue&type=script&lang=js"
export * from "./ModelCrudButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports